import styled from "styled-components";

export const Mail = styled.a`
  font-family: Open Sans;
  font-size: 20px;
  font-weight: 700;
  line-height: 27.24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: white;
  &:hover {
    color: #f08a67;
  }
  @media (max-width: 64em) {
    align-self: center;
  }
`;
